import Alpine from "@alpinejs/csp";
import formField from "../components/custom-form-theme/FormField";
import passwordField from "../components/custom-form-theme/PasswordField";
import checkboxField from "../components/custom-form-theme/CheckboxField";
window.Alpine = Alpine;


/**
 * Pour utiliser nos composants liés au custom form theme Symfony
 */
export function ap_bootstrapAlpineFormComponents() {
    Alpine.data('cft_formField', formField)
    Alpine.data('cft_passwordField', passwordField)
    Alpine.data('cft_checkboxField', checkboxField)

    Alpine.data('cft_createField', function () {
        const { type, name, storeName } = extractFieldConfig(this.$el)

        const store = this.$store[storeName]

        if (type === 'password') {
            return passwordField(name, false, store)
        }
        if (type === 'checkbox') {
            return checkboxField(name, store)
        }

        return formField(name, store)
    })
}

/**
 * Extrait la configuration d'un champ à partir de l'élément DOM
 * @param el
 * @returns {{type: string, name: string, storeName: string}}
 */
function extractFieldConfig(el) {
    return {
        type: el.dataset.fieldType,
        name: el.dataset.fieldName,
        storeName: el.dataset.storeName,
    }
}

/**
 * Met en place un formulaire Alpine à partir de la conf fournie
 * @param formConfig
 */
export function ap_setupForm({ store, form, components = [], debug = false }) {

    if (debug) console.log("Setting up form:", store.name)

    // le store doit être créé immédiatement
    if (debug) console.log("Creating store :", store.name)
    const storeInstance = store.callback(form.name, store.name, store.params ?? {} )
    Alpine.data(store.name, storeInstance  )
    if (debug) console.log("Store created :", store.name)
    Alpine.data(form.name, form.callback  )

    for (const component of components) {
        Alpine.data(component.name, component.instance)
    }
}
